import { render, staticRenderFns } from "./InspectionTaskManage.vue?vue&type=template&id=4e3a5d4e&scoped=true&"
import script from "./InspectionTaskManage.vue?vue&type=script&lang=js&"
export * from "./InspectionTaskManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e3a5d4e",
  null
  
)

export default component.exports